import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import Event from '@/components/Event';
import type { AgendaTask } from '../types';
import { classes, getOffset, isOrderTask, styles } from './utils';

export type AgendaEventProps = {
  style?: CSSProperties;
  className?: string;
  offsetTop?: string;
  agendaTask: AgendaTask;
  hourHeight: number;
};

export default function AgendaEvent({
  style = {},
  className,
  offsetTop = '0px',
  agendaTask,
  hourHeight,
}: AgendaEventProps) {
  const { task } = agendaTask;
  const offset = getOffset(task.dueAt, hourHeight);

  return (
    <div
      style={{ ...styles.wrapper(hourHeight, offset, offsetTop), ...style }}
      className={twMerge(classes.wrapper, className)}>
      {isOrderTask(agendaTask) ? (
        <Event className={classes.event} orderTask={agendaTask} />
      ) : (
        <Event className={classes.event} unisonProjectTask={agendaTask} />
      )}
    </div>
  );
}
